import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";

export type EventJoinModalProps = {
  handleJoin: () => void;
  selectedUserId: string;
  selectedUserName: string;
  type: string;
  title: string;
  message: string;
  children?: React.ReactNode;
}

export const EventJoinModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handleJoin,
  selectedUserId,
  selectedUserName,
  children,
  type,
  title,
  message,
}: ModalProp & EventJoinModalProps) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center sm:mt-3">
            <Dialog.Title
              as="h3"
              className="text-left text-lg font-medium leading-6 text-gray-900"
            >
              {title}
            </Dialog.Title>
          </div>
          <div className="mt-5">
            {message}<br />
            {type !== 'error' && (
              <>
                利用者番号：{selectedUserId}<br />
                利用者名：{selectedUserName}
              </>
            )}
          </div>
        </div>
        <ModalFoterBox>
          {type === 'error' || type === 'success' ? (
            <Button
              className="mt-1"
              onClick={toggle}
              children={"閉じる"}
            />
          ) : (
            <>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
                children={"キャンセル"}
              />
              <Button
                className="mt-1 mr-2 w-[132px]"
                onClick={() => handleJoin()}
                children={"参加"}
              />
            </>
          )}
        </ModalFoterBox>
        {children}
      </Dialog.Panel>
    </Modal>
  );
}